// @ts-nocheck
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../../../runtime/json/scalar";
import { default as serialize, } from "../../../../runtime/wire/serialize";
import { tsValueToWireValueFns, wireValueToTsValueFns, } from "../../../../runtime/wire/scalar";
import { default as deserialize, } from "../../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        stockCount: "0",
        autofill: false,
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    if (value.stockCount !== undefined)
        result.stockCount = tsValueToJsonValueFns.int64(value.stockCount);
    if (value.autofill !== undefined)
        result.autofill = tsValueToJsonValueFns.bool(value.autofill);
    return result;
}
export function decodeJson(value) {
    const result = getDefaultValue();
    if (value.stockCount !== undefined)
        result.stockCount = jsonValueToTsValueFns.int64(value.stockCount);
    if (value.autofill !== undefined)
        result.autofill = jsonValueToTsValueFns.bool(value.autofill);
    return result;
}
export function encodeBinary(value) {
    const result = [];
    if (value.stockCount !== undefined) {
        const tsValue = value.stockCount;
        result.push([1, tsValueToWireValueFns.int64(tsValue)]);
    }
    if (value.autofill !== undefined) {
        const tsValue = value.autofill;
        result.push([2, tsValueToWireValueFns.bool(tsValue)]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.int64(wireValue);
        if (value === undefined)
            break field;
        result.stockCount = value;
    }
    field: {
        const wireValue = wireFields.get(2);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.bool(wireValue);
        if (value === undefined)
            break field;
        result.autofill = value;
    }
    return result;
}
